import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });
export const channelApi = axios.create({ baseURL: `${BACKEND}/api/channel` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cm_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

channelApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("cm_channel_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (id) => (id ? `${BACKEND}/api/media/${id}/file` : "");

export const errText = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  if (d && typeof d.message === "string") return d.message;
  return fallback;
};
